import PropTypes from "prop-types"
import React, {useEffect} from "react"
import {useTranslation} from "react-i18next"
import {apiBuscarFornecedoresPesquisa} from "../../helpers/backend_helper"
import FormFilterAsyncSelect from "./form-filter-async-select"


const FormFilterFornecedor = props => {
    const { attribute, placeholder, description, empresas, value, setValue, multiple, exigeEmpresa } = props
    const { t } = useTranslation()

    const semEmpresa = !empresas || empresas.length === 0
    const chaveEmpresas = (empresas || []).join(",")

    useEffect(() => {
        if (multiple || !value || (semEmpresa && !exigeEmpresa)) return
        if (!(empresas || []).includes(value.idEmpresa)) setValue(null)
    }, [chaveEmpresas])

    const buildFornecedor = (codigo, cnpj, razaosocial, idEmpresa) => {
        return {label: `${cnpj} - ${razaosocial}`, value: codigo, idEmpresa}
    }

    const buscarFornecedores = (inputValue, callback) => {
        if (exigeEmpresa && semEmpresa) {
            callback([])
            return
        }
        return apiBuscarFornecedoresPesquisa({empresaId: empresas, argumento: inputValue})
            .then(results => {
                const options = results.map(({codigo, cnpj, razaosocial, idEmpresa}) => {
                    return buildFornecedor(codigo, cnpj, razaosocial, idEmpresa)
                })
                callback(options)
            })
    }

    return (
        <React.Fragment>
            <FormFilterAsyncSelect
                attribute={ attribute || 'fornecedor' }
                description={ description || ( 'Fornecedor' + (multiple ? '(s)' : '')) }
                placeholder={ placeholder || `Digite o ${description}...` }
                value={value}
                multiple={ multiple }
                setValue={ setValue }
                searchOptions={ buscarFornecedores }
                dependencyKey={ chaveEmpresas }
                noOptionsMessage={ exigeEmpresa && semEmpresa ? t("fornecedor.pesquisa.sem_empresa") : undefined }
            />
        </React.Fragment>
    )
}

FormFilterFornecedor.propTypes = {
    attribute: PropTypes.string,
    description: PropTypes.string,
    placeholder: PropTypes.string,
    multiple: PropTypes.bool,
    value: PropTypes.any,
    empresas: PropTypes.array,
    setValue: PropTypes.func,
    exigeEmpresa: PropTypes.bool,
}

export default FormFilterFornecedor
